import { BaseStore, makeObservable, observable } from "@core-ui/react-mobx-state";

class UIStore extends BaseStore {
  @observable public pageLoading = true;
  @observable public useHeader = false;
  @observable public openMobileMenu = false;
  @observable public clipboardText = "";
  @observable public loadingStatus: string = "";
  @observable public showFixedMenu: boolean = false;

  constructor() {
    super();
    makeObservable(this);
  }

}

export default UIStore;
